<template>
    <div class="list-unstyled">
        <div class="left">
            <div>
                <strong>{{ $t("message.forWindows") }}</strong>
                <hr />
            </div>
            <div>
                <b-badge>1</b-badge>
                ,
                <b-badge>2</b-badge>
                ,
                <b-badge>3</b-badge>
                ...
                {{ $t("message.shortcut_desc_num") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>M</b-badge>
                {{ $t("message.openPrivateChat") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>↑</b-badge>
                {{ $t("message.closeActiveChat") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>→</b-badge>
                {{ $t("message.nextChatFromActive") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>←</b-badge>
                {{ $t("message.previousChatFromActive") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>↓</b-badge>
                {{ $t("message.hideActiveChat") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>↓</b-badge>
                {{ $t("message.archiveChatKey") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>,</b-badge>
                {{ $t("message.chatCopilot") }}
            </div>
            <div>
                <b-badge>ESC</b-badge>
                {{ $t("message.escKey") }}
            </div>
            <div>
                <b-badge>F1</b-badge>
                {{ $t("message.focusInput") }}
            </div>
            <div>
                <b-badge>F2</b-badge>
                {{ $t("message.firsthiddenChat") }}
            </div>
            <div>
                <b-badge>F3</b-badge>
                {{ $t("message.firstChatWaiting") }}
            </div>
            <div>
                <b-badge>F4</b-badge>
                {{ $t("message.previousOpenedChat") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>,</b-badge>
                {{ $t("message.copilot_desc_num") }}
            </div>
        </div>
        <div class="right">
            <div style="margin-top: 10px">
                <strong>{{ $t("message.forMac") }}</strong>
                <hr />
            </div>
            <div>
                <b-badge>1</b-badge>
                ,
                <b-badge>2</b-badge>
                ,
                <b-badge>3</b-badge>
                ...
                {{ $t("message.shortcut_desc_num") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>M</b-badge>
                {{ $t("message.openPrivateChat") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>↑</b-badge>
                {{ $t("message.closeActiveChat") }}
            </div>
            <div>
                <b-badge>OPT</b-badge>
                +
                <b-badge>→</b-badge>
                {{ $t("message.nextChatFromActive") }}
            </div>
            <div>
                <b-badge>OPT</b-badge>
                +
                <b-badge>←</b-badge>
                {{ $t("message.previousChatFromActive") }}
            </div>
            <div>
                <b-badge>OPT</b-badge>
                +
                <b-badge>↓</b-badge>
                {{ $t("message.hideActiveChat") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>↓</b-badge>
                {{ $t("message.archiveChatKey") }}
            </div>
            <div>
                <b-badge>CTRL</b-badge>
                +
                <b-badge>,</b-badge>
                {{ $t("message.chatCopilot") }}
            </div>
            <div>
                <b-badge>ESC</b-badge>
                {{ $t("message.escKey") }}
            </div>
            <div>
                <b-badge>F1</b-badge>
                {{ $t("message.focusInput") }}
            </div>
            <div>
                <b-badge>F2</b-badge>
                {{ $t("message.firsthiddenChat") }}
            </div>
            <div>
                <b-badge>F3</b-badge>
                {{ $t("message.firstChatWaiting") }}
            </div>
            <div>
                <b-badge>F4</b-badge>
                {{ $t("message.previousOpenedChat") }}
            </div>
            <div>
                <b-badge>Command</b-badge>
                +
                <b-badge>,</b-badge>
                {{ $t("message.copilot_desc_num") }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "KeyboardShortcuts",
};
</script>

<style scoped>
.list-unstyled {
    display: flex;
    align-items: flex-end;
    gap: 10px;

    .left {
        display: grid;
        div {
            margin-bottom: 5px;
        }
    }

    .right {
        display: grid;

        div {
            margin-bottom: 5px;
        }
    }
}
</style>
